import { render, staticRenderFns } from "./SalesRepShares.vue?vue&type=template&id=0a7add00&"
import script from "./SalesRepShares.vue?vue&type=script&lang=ts&"
export * from "./SalesRepShares.vue?vue&type=script&lang=ts&"
import style0 from "./SalesRepShares.vue?vue&type=style&index=0&id=0a7add00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports